export default __webpack_public_path__ + "static/media/hurricane-ida-relief-3.826aa54d.png";